
import PropTypes from 'prop-types'
import { StaticQuery, Link, graphql } from 'gatsby'
import React, { Component } from "react";

/* import logo from '../assets/favicon/android-icon-48x48.png'
<img src={logo}></img> */


const goBack = () => {
  if (window && window !== 'undefined') {
    window.history.back();
  }
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.state = 
    {
        message: "",
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  componentDidMount() {

  }

  render() {
    var back = false;
    if (typeof window !== 'undefined') {
      if (window.location.origin + "/" !== window.location.href) {
        back = true;
      }
    }
    return (
      <StaticQuery
        query={graphql`
          query HeadingQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
                  <header id="header" className={this.props.cl + " alt"}>
                    {/* {back ? (<Link to="/" onClick={goBack} className="logo-back link-no-dots"><span className="icon fa-chevron-left"></span></Link>) : (<></>)} */}
                    <Link to="/" className="logo no-select"><span>{data.site.siteMetadata.title}</span></Link>
                    <nav >
                        <a className="menu-link no-select" onClick={this.props.onToggleMenu} role="button" tabIndex="0">Menu</a>
                    </nav>
                  </header>
                )}
            />
        )
    }
}
export default Header